
import { defineComponent, ref } from "vue";
import { hideModal } from "@/core/helpers/dom";
import { ApiApp } from "@/core/api";
import mixin from "@/mixins";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "add-app-modal",
  components: {},
  emits: ["update-list"],
  props: {
    selectData: {
      type: Array,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const formRef = ref<null | HTMLFormElement>(null);
    const addAppModalRef = ref<null | HTMLElement>(null);
    const submitButton = ref<HTMLElement | null>(null);
    const loading = ref<boolean>(false);
    const {
      showValidateErrorMsg,
      showFormSubmitSuccessMsg,
      showServerErrorMsg,
    } = mixin();

    const formData = ref({
      status: 10,
      name: "",
      type: "",
      short_key: "",
      frontend_base_url: "",
      rest_api_url: "",
      rpc_namespace: "",
      overall_notes: "",
    });

    const rules = ref({
      status: [
        {
          required: true,
          message: t("common.status") + t("common.isRequired"),
          trigger: "change",
        },
      ],
      name: [
        {
          required: true,
          message: t("permissions.appName") + t("common.isRequired"),
          trigger: "change",
        },
      ],
      // type: [
      //   {
      //     required: true,
      //     message: "Type is required",
      //     trigger: "change",
      //   },
      // ],
      short_key: [
        {
          required: true,
          message: t("permissions.shortKey") + t("common.isRequired"),
          trigger: "change",
        },
      ],
    });

    const submit = () => {
      if (!formRef.value) {
        return;
      }

      formRef.value.validate((valid) => {
        if (valid) {
          loading.value = true;
          if (submitButton.value) {
            submitButton.value.setAttribute("data-kt-indicator", "on");
          }
          ApiApp.addApp(formData.value)
            .then(({ data }) => {
              loading.value = false;
              submitButton.value?.removeAttribute("data-kt-indicator");
              if (data.code == 0) {
                showFormSubmitSuccessMsg(() => {
                  resetForm();
                  hideModal(addAppModalRef.value);
                  emit("update-list");
                });
              } else {
                showServerErrorMsg(data);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          showValidateErrorMsg();
          return false;
        }
      });
    };

    const handleDiscard = () => {
      hideModal(addAppModalRef.value);
    };

    const resetForm = () => {
      formRef.value?.resetFields();
    };

    return {
      t,
      loading,
      formData,
      rules,
      formRef,
      addAppModalRef,
      submitButton,
      submit,
      handleDiscard,
      resetForm,
    };
  },
});
